<template>
  <div>
    <!--账户管理-->
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>账户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <div class="handle_box">
        <!--查询盒子-->
        <el-input placeholder="用户名" class="handle_input" v-model="GetUserList.params.username" clearable></el-input>
        <el-input placeholder="用户持有者姓名" class="handle_input" v-model="GetUserList.params.name" clearable></el-input>
        <el-select placeholder="用户组" class="handle_select" v-model="GetUserList.params.role" clearable>
          <el-option :value="0" label="超级管理员"></el-option>
          <el-option :value="1" label="普通管理员"></el-option>
          <el-option :value="2" label="维修人员"></el-option>
        </el-select>
        <el-button type="primary" style="margin-top: 40px; margin-left: 20px;" icon="el-icon-search" @click="getUserList">查询</el-button>
      </div>
      <el-table style="margin-top: 20px; font-size: 14px;" :data="userList.result.userList.slice((currentPage-1)*10, currentPage*10)">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="用户名" prop="username" width="100"></el-table-column>
        <el-table-column label="用户持有者姓名" prop="name" width="150"></el-table-column>
        <!--<el-table-column label="账户密码" prop="password" width="150"></el-table-column>-->
        <el-table-column label="用户角色" prop="role" width="130">
          <template slot-scope="scope">
            <el-tag>{{getRole(scope.row.role)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户负责区域名称" prop="areaName" width="160"></el-table-column>
        <el-table-column label="联系电话" prop="phoneNumber" width="150"></el-table-column>
        <el-table-column label="操作" width="350" align="center" fixed="right">
          <template slot-scope="scope">
            <!--<el-button type="text" @click="openChangeRoleDialog(scope.row)">变更用户组</el-button>-->
            <!--<el-button type="text" @click="openUpdateAreaDialog(scope.row)">变更负责区域</el-button>-->
            <el-button type="text" @click="openUpdateAreaDialog(scope.row)">变更负责区域</el-button>
            <el-button type="text" @click="showUpdatePhoneNumberDialog(scope.row)">变更联系电话</el-button>
            <!--<el-button type="text" @click="checkUser">查看用户</el-button>-->
            <el-button type="text" @click="deleteUser(scope.row)" style="color:red;">删除用户</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="addButton">
        <el-button type="primary" size="medium" @click="openAddUserDialog">添加用户</el-button>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          :page-size="10"
          :total="userList.result.userList.length">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="updatePhoneNumberDialogVisible" @close="updatePhoneNumberDialogVisible = false" title="修改联系电话" v-if="updatePhoneNumberDialogVisible">
      <el-form>
        <el-form-item label="新联系电话">
          <el-input v-model="UpdatePhoneNumber.params.newPhoneNumber"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUpdatePhoneNumberDialogVisible">取 消</el-button>
        <el-button type="primary" @click="updatePhoneNumber">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="updateAreaDialogVisible" @close="updateAreaDialogVisible = false" title="修改管理区域" v-if="updateAreaDialogVisible">
      <el-form>
        <el-form-item label="新联系电话">
          <el-input v-model="UpdatePhoneNumber.params.newPhoneNumber"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateAreaDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePhoneNumber">确定</el-button>
      </div>
    </el-dialog>
    <AddUser :add-user-dialog-visible="addUserDialogVisible" @feedBack="getAddUserFeedBack"></AddUser>
    <ChangeRole :change-role-dialog-visible="changeRoleDialogVisible" :original-role="originalRole" @feedBack="getChangeRoleFeedBack"></ChangeRole>
    <UpdateArea :update-area-dialog-visible="updateAreaDialogVisible" :original-area-name="originalAreaName" :user-id="chosenUserId" @feedBack="getUpdateAreaFeedBack"></UpdateArea>
  </div>
</template>

<script>
import AddUser from './AddUser'
import ChangeRole from './ChangeRole'
import UpdateArea from './UpdateArea'
export default {
  name: 'UserManage',
  components: { UpdateArea, ChangeRole, AddUser },
  data() {
    return {
      updatePhoneNumberDialogVisible: false,
      updateAreaManagerDialogVisible: false,
      chosenUserId:'',
      currentPage: 1,
      originalRole:'',
      originalAreaName:'',
      addUserDialogVisible: false, // 添加用户模态框显示与否
      changeRoleDialogVisible: false,// 改变用户组模态框显示与否
      updateAreaDialogVisible: false, // 更改负责区域模态框显示与否
      // 获取用户列表
      GetUserList:{
        "version": 1,
        "method": "user.GetUserList",
        "params": {
          "username":"",
          "name":"",
          "role":""
        },
        "token": "",
        "id": 0
      },
      // 账户列表
      userList:{
        "version": 1,
        "result":{
          "userList":[],
        },
        "id": 0
      },
      // 删除用户
      DeleteUser:{
        "version": 1,
        "method": "user.DeleteUser",
        "params": {
          "userId": 1
        },
        "token": "",
        "id": 0
      },
      UpdatePhoneNumber:{
        "version": 1,
        "method": "user.UpdatePhoneNumber",
        "params": {
          "userId": "",
          "newPhoneNumber":""
        },
        "token": "",
        "id": 0
      },
    }
  },
  methods: {
    closeUpdatePhoneNumberDialogVisible(){
      this.updatePhoneNumberDialogVisible = false;
      this.cleanArguments(this.UpdatePhoneNumber.params);
    },
    // showUpdateAreaDialog(row){
    //   this.chosenUserId = row._id;
    //   this.updateAreaDialogVisible = true;
    // },
    // 修改用户手机号
    updatePhoneNumber(){
      this.UpdatePhoneNumber.token = this.$store.state.token;
      this.UpdatePhoneNumber.params.userId = this.chosenUserId;
      console.log('修改用户联系方式请求');
      console.log(this.UpdatePhoneNumber);
      this.$axios.post(this.$mainUrl, this.UpdatePhoneNumber).then(res =>{
        console.log('修改用户联系方式请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'修改用户联系方式成功'
          })
          this.updatePhoneNumberDialogVisible = false;
          this.getUserList();
          // this.feedBack();
        }else{
          this.$message({
            type:'error',
            message:'修改用户联系方式请求失败，' + res.data.error.message
          })
        }
      })
    },
    showUpdatePhoneNumberDialog(row){
      this.chosenUserId = row._id;
      this.updatePhoneNumberDialogVisible = true;
    },
    handleCurrentChange(currentPage){
      this.currentPage = currentPage;
    },
    // 删除用户
    deleteUser(row){
      this.DeleteUser.params.userId = row._id;
      this.DeleteUser.token = this.$store.state.token;
      console.log('删除用户请求');
      console.log(this.DeleteUser);
      this.$confirm('此操作将删除用户“' + row.username + '”，是否继续', '提示', {
        confirmButtonText:'删除',
        cancelButtonText:'取消',
        type:'warning'
      }).then(()=>{
        this.$axios.post(this.$mainUrl, this.DeleteUser).then( res =>{
          if(res.data.hasOwnProperty('result')){
            console.log('删除成功');
            this.$message({
              type: 'success',
              message: `删除成功`
            });
            this.getUserList();
          }else{
            console.log('删除失败');
            this.$message({
              type:'error',
              message: '删除失败，失败原因：' + res.data.error.message
            })
          }
        })
      }).catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 获取用户列表
    getUserList(){
      for(let key in this.GetUserList.params){
        if(this.GetUserList.params[key] === ""){
          this.GetUserList.params[key] = null;
        }
      }
      this.GetUserList.token = this.$store.state.token;
      console.log('获取用户列表请求');
      console.log(this.GetUserList);
      this.$axios.post(this.$mainUrl, this.GetUserList).then(res =>{
        console.log('获取用户列表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'获取用户列表成功'
          })
          this.userList = res.data;
          this.userList.result.userList.reverse();
        }else{
          this.$message({
            type:'error',
            message:'获取用户列表失败，' + res.data.error.message
          })
        }
      })

    },
    checkUser(){
      this.$message({
        message:'施工未完成。。。'
      })
    },
    getRole(role){
      if(role === 0){
        return "超级管理员";
      }else if(role === 1){
        return "普通管理员";
      }else if(role === 2){
        return "维修人员";
      }else {
        return "角色错误";
      }
    },
    getAddUserFeedBack(addUserDialogVisible){
      this.addUserDialogVisible = addUserDialogVisible;
      this.getUserList();
    },
    openAddUserDialog(){
      this.addUserDialogVisible = true;
    },
    openChangeRoleDialog(row){
      this.originalRole = row.role;
      // 打开改变用户组模态框
      this.changeRoleDialogVisible = true;
    },
    getChangeRoleFeedBack(changeRoleDialogVisible){
      this.changeRoleDialogVisible = changeRoleDialogVisible;
    },
    openUpdateAreaDialog(row){
      this.chosenUserId = row._id;
      this.originalAreaName = row.areaName;
      if(this.originalAreaName === ""){
        this.originalAreaName = '无'
      }
      this.updateAreaDialogVisible = true;
    },
    getUpdateAreaFeedBack(updateAreaDialogVisible){
      this.updateAreaDialogVisible = updateAreaDialogVisible;
      this.getUserList();
    }
  },
  mounted(){
    this.getUserList();
  }
}
</script>

<style scoped>
  .handle_input{
    width: 200px;
    height: 16px;
    margin-left: 20px;
    display: inline-block;

  }
  .handle_select{
    width: 120px;
    margin-left: 20px;
    display: inline-block;
  }
  .handle_box{
    margin-top: -30px;
  }
  .addButton{
    text-align: left;
    margin-top: 20px;
    position: relative;
    float: left;
  }
  .pagination{
    position: relative;
    float: right;
    margin-top: 20px;
    text-align: right;
  }
</style>
